/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pw_uppercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppercase (A-Z)`)
};

const es_pw_uppercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mayúsculas (A-Z)`)
};

const de_pw_uppercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Großbuchstaben (A-Z)`)
};

const nl_pw_uppercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoofdletters (A-Z)`)
};

const fr_pw_uppercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Majuscules (A-Z)`)
};

const it_pw_uppercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maiuscole (A-Z)`)
};

const pt_br2_pw_uppercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maiúsculas (A-Z)`)
};

const pt_pw_uppercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maiúsculas (A-Z)`)
};

const ja_pw_uppercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大文字 (A-Z)`)
};

const zh_pw_uppercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大写字母 (A-Z)`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pw_uppercase = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pw_uppercase(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pw_uppercase", locale)
	if (locale === "en") return en_pw_uppercase(inputs)
	if (locale === "es") return es_pw_uppercase(inputs)
	if (locale === "de") return de_pw_uppercase(inputs)
	if (locale === "nl") return nl_pw_uppercase(inputs)
	if (locale === "fr") return fr_pw_uppercase(inputs)
	if (locale === "it") return it_pw_uppercase(inputs)
	if (locale === "pt-BR") return pt_br2_pw_uppercase(inputs)
	if (locale === "pt") return pt_pw_uppercase(inputs)
	if (locale === "ja") return ja_pw_uppercase(inputs)
	return zh_pw_uppercase(inputs)
};